import { Component, ElementRef, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ProgressService } from '../../service/progress.service';
import { BaseModalComponent } from '../../common/modal/base-modal/base-modal.component';
import { User } from '../../model/auth/User';
import { saveAs } from 'file-saver';
import { Region } from '../../model/location/Region';

export interface ChangePassResultResult {
  users: User[];
  changePassResults: Map<string, string>;
  regions?: Region[];
}

@Component({
  selector: 'app-change-pass-result-modal',
  templateUrl: './change-pass-result-modal.component.html',
  styleUrls: ['./change-pass-result-modal.component.scss']
})
export class ChangePassResultModalComponent extends BaseModalComponent {

  @ViewChild('dialogContent', {static: true}) protected progressContainer!: ElementRef;

  users: User[];
  changePassResults?: Map<string, string>;
  regions: Map<string, string> = new Map<string, string>();

  constructor(dialogRef: MatDialogRef<ChangePassResultResult>,
              progressService: ProgressService,
              @Inject(MAT_DIALOG_DATA) data: ChangePassResultResult) {
    super(dialogRef, progressService);

    this.users = data.users || [];
    this.changePassResults = data.changePassResults;
    (data.regions || []).forEach(region => this.regions.set(region.id, region.name));
  }

  proceedAllowed(): boolean {
    return true;
  }

  proceed(): void {
  }

  downloadFile(users: User[]) {
    const replacer = (key: string, value: string) => value || ''; // specify how you want to handle null values here
    const header = ['first_name', 'last_name', 'identifier', 'password', 'region', 'school'];

    const csv = users
      .map(user => [
        user.firstName,
        user.lastName,
        user.username,
        this.changePassResults?.get(user.id),
        user.region ? this.regions.get(user.region) || user.region : '',
        user.schoolName
      ]
        .map(value => JSON.stringify(value, replacer))
        .join(','));

    csv.unshift(header.join(','));

    const csvArray = csv.join('\r\n');

    const blob = new Blob([csvArray], {type: 'text/csv'});

    saveAs(blob, `users-access-${new Date().getTime()}.csv`);
  }
}
